import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IAffiliateProfileResponse,
} from '../types';
import {
  AFFILIATE_PROFILE_GET_QUERY_KEY,
  AFFILIATE_PROFILE_GET_URL,
} from '../constants';

export default function useAffiliatesProfileGetQuery(id: Ref<number>): IContextQueryResult<
  IAffiliateProfileResponse
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<
    IAffiliateProfileResponse
  >({
    queryKey: [AFFILIATE_PROFILE_GET_QUERY_KEY, id],
    queryFn: ({ signal }) => fetchGet<IAffiliateProfileResponse>(
      AFFILIATE_PROFILE_GET_URL,
      {
        urlParams: { id: id.value },
        signal,
      },
    ),
    enabled: computed(() => !!id.value),
  });
}
